import { propertyUseQuery, propertyQueryFn } from 'Services/reactQuery'


export const useFetchArchiveListings = ({ id, component, payload, token }) => {
  const {
    buildingId, addressId, perPage, suiteNumber, offer,
    bedTypeNum, bedTypeCategory, offset,
  } = payload

  const params = {
    offset: 0,
  }
  if(buildingId) params.building_id = buildingId
  if(perPage) params.limit = perPage
  if(suiteNumber) params.unit_name = suiteNumber
  if(offer && offer !== 'All') params.offer = offer

  if(bedTypeNum && bedTypeNum !== '-1') params.bed_type_num = bedTypeNum
  if(bedTypeCategory) params.bed_type_category = bedTypeCategory
  if(offset) params.offset = offset
  // add address id filer if unit name filter
  if(!buildingId || (params.unit_name && addressId)) params.address_id = addressId

  const paramsString = new URLSearchParams(params).toString()
  return (
    propertyUseQuery(
      [component, id, paramsString, token],
      propertyQueryFn({
        url: `archive-listings?${paramsString}`,
        token,
      }),
      { enabled: Boolean(id && component) })
  )
}
